export const BASIC = 'basic';
export const CLASS = 'class';
export const ALPHA = 'alpha';
export const GOLD = 'gold';



// WEBPACK FOOTER //
// ./src/data/ids/catalyst.js